import { useThemeStore } from '../../state/theme';

const Loader = () => {
  const { isDarkMode } = useThemeStore();

  return (
    <div className="flex items-center justify-center h-screen bg-transparent">
      <div
        className={`size-11 rounded-full border-4 border-t-transparent animate-spin ${
          isDarkMode ? 'border-gray-300' : 'border-greySeventy'
        }`}
      ></div>
    </div>
  );
};

export default Loader;
